var React = require('react');

function ArrowCircleUp32x32 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Size=30, Inverted=off, State=Default","stroke":"currentColor","strokeWidth":"2"},[React.createElement("g",{"id":"Icon/Arrow-reg","key":0},[React.createElement("path",{"id":"Vector","d":"M21 16l-4.5-5h-1L11 16","strokeMiterlimit":"10","strokeLinecap":"round","key":0}),React.createElement("path",{"id":"Vector_2","d":"M16 22V11","strokeLinejoin":"bevel","key":1})]),React.createElement("rect",{"x":"1","y":"1","width":"30","height":"30","rx":"15","key":1})]));
}

ArrowCircleUp32x32.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = ArrowCircleUp32x32;

ArrowCircleUp32x32.default = ArrowCircleUp32x32;
